<template>
  <div class="mb-6">
    <div
      class="rounded text-red-1 w-full focus:outline-hidden bg-white text-left p-4 pr-2 border-2px border-red-1 ring-2 ring-red-light overflow-auto cursor-pointer"
      :class="{ 'h-auto': open }"
      @click="toggleOpen">

      <div class="flex">
        <span class="w-full mp2 md:p2" data-test="privacyDropDown">
          {{ statement?.title || 'Please read our privacy collection statement' }}
        </span>
        <dropdown-arrow
          class="self-center mr-4"
          stroke="#888"
          :class="open ? 'transform rotate-0' : 'transform rotate-180'" />
      </div>

      <div v-if="open && statement" class="py-3 text-grey-1">
        <div class="paragraph-2">
          <span  v-html='statement.content'/>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import DropdownArrow from '@/components/icons/DropdownArrow.vue'
import type { SuperfundPrivacyStatement } from '@/types/SuperfundDisclaimerTypes'

interface Props {
  statement: SuperfundPrivacyStatement | null
  open: boolean
}

interface Emits {
  (e: 'toggle'): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const toggleOpen = () => {
  emit('toggle')
}
</script>
